export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            initOnRender: false,
            global_search: {
                visibility: false,
            }
        },

        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'export'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            // ellatohely
            {
                name: "siteName",
                label: "Ellátóhely",
                visibility: true
            },
            {
                name: "hierarchy",
                label: "Cég struktúra",
                visibility: true
            },
            {
                name: "feorCode",
                label: "FEOR kód",
                visibility: true
            },
            {
                name: "siteGroupName",
                label: "Munkakör",
                visibility: true
            },
            {
                name: "jobCategory",
                label: "FEÜ kategória",
                visibility: true
            },
            {
                name: "employeeId",
                label: "Törzsszám",
                visibility: true
            },
            {
                name: "status",
                label: "Státusz",
                visibility: true
            },
            {
                name: "patientName",
                label: "Páciens neve",
                visibility: true
            },
            {
                name: "patientSex",
                label: "Nem",
                visibility: true
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ szám",
                visibility: true
            },
            {
                name: "dateOfBirth",
                label: "Szül. dátum",
                slot_name: "date_format",
                formSize: 3,
                formType: "date",
                visibility: true
            },
            {
                name: "patientEmail",
                label: "Email cím",
                visibility: true
            },
            {
                name: "doctorName",
                label: "Vizsgáló orvos",
                formSize: 3,
                formType: "text",
                visibility: true
            },
            {
                name: "treatmentType",
                label: "Vizsgálat típusa",
                visibility: true
            },
            {
                name: "capableStatus",
                label: "Eredmény",
                visibility: true
            },
            {
                name: "appointment",
                label: "Vizsgálat dátuma",
                formType: "date",
                visibility: true
            },
            {
                name: "validity",
                label: "Lejárati dátum",
                visibility: true
            },
            {
                name: "restriction",
                label: "Korlátozás",
                visibility: true,
                formVisible: true,
                formSize: 6,
            },
            {
                name: "customRestriction",
                label: "Egyéni korlátozás",
                visibility: true,
                formVisible: true,
                formSize: 6,
                formType: "textarea"
            },
            {
                name: "isManager",
                label: "Menedzser",
                visibility: true
            },
        ]
    }
}
